import type { PreviewAction } from '../../core/events';
import { AskForm } from './AskForm';
import { ProductIntroduction } from './ProductIntroduction';

export const SUBSCRIPTION_URL = 'https://www.240tutoring.com/';
export const OBJECTIVES_URL = 'https://objectives.labs.240.org/';

export function SubscriptionPreview({ onRetry, onTrack }: {
  onRetry(): void;
  onTrack(action: PreviewAction, properties?: Record<string, string | number | boolean | string[]>): void;
}) {
  return <div className="subscription-preview">
    <ProductIntroduction />
    <section className="subscription-notice" aria-labelledby="subscription-title">
      <div className="eyebrow">INCLUDED WITH A 240 SUBSCRIPTION</div>
      <h2 id="subscription-title">Get a 240 subscription to use One Step Ahead.</h2>
      <p>Find your next unit’s official standards and the 240 study material to help you teach it. An active subscription unlocks the form below.</p>
      <div className="subscription-actions">
        <a className="primary" href={SUBSCRIPTION_URL} target="_blank" rel="noopener noreferrer" onClick={() => onTrack('subscription_cta_clicked', { destination: SUBSCRIPTION_URL, placement: 'subscription_preview' })}>Get a 240 subscription <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
        <button className="text-button" type="button" onClick={onRetry}>Already subscribed? Check again</button>
      </div>
      <div className="subscription-alternative">
        <p><strong>Looking for a free option?</strong> Standard Checker checks lessons and materials you found against academic standards.</p>
        <a href={OBJECTIVES_URL} target="_blank" rel="noopener noreferrer" onClick={() => onTrack('alternative_product_clicked', { destination: OBJECTIVES_URL, destination_product: 'objectives', placement: 'subscription_preview' })}>Try Standard Checker for free <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
      </div>
    </section>
    <AskForm initial={null} busy={false} usage={null} subscriptionRequired onSubmit={() => {}} onTrack={onTrack} />
  </div>;
}
